import PropTypes from 'prop-types';
import React from 'react';
import FlagIconFactory from 'react-flag-icon-css';

// ==============================|| FLAG ICON ||============================== //

const FlagIcon = FlagIconFactory(React, { useCssModules: false });

const LocaleFlagIcon = ({ lang }) => {
    switch (lang) {
        case 'en':
            return <FlagIcon code="gb" />;
        case 'es':
            return <FlagIcon code="es" />;
        default:
            return <FlagIcon code="pt" />;
    }
};

LocaleFlagIcon.propTypes = {
    lang: PropTypes.string
};

export default LocaleFlagIcon;
